import React from "react";
import styles from "./mortgage-cat.module.scss";
import HomebuddyMort from "../../assets/mortgage-homebuddy.svg";
import ExternalMort from "../../assets/mortgage-external.svg";
import FxMort from "../../assets/mortgage-fx.svg";
import EligilityMort from "../../assets/mortgage-eligibility.svg";
import { useHistory } from "react-router";

const MortgageCategories = () => {
  const history = useHistory();

  const list = [
    {
      text: "Mortgage Eligibility Status",
      color: "rgba(91, 35, 51, 0.2)",
      logo: EligilityMort,
      nav: "/j-eligibility",
      identifier: "ELIGIBILITY",
    },
    {
      text: "HomeBuddy Mortgage Properties",
      color: "rgba(219, 84, 97, 0.2)",
      logo: HomebuddyMort,
      nav: "/mortgage?morf=homebuddy-mort",
    },
    {
      text: "External Mortgage Properties",
      color: "rgba(32, 32, 48, 0.2)",
      logo: ExternalMort,
      nav: "/external-eligibility?morf=external-mort",
    },
    {
      text: "FX Rate",
      color: "#F5F5F5",
      logo: FxMort,
      nav: "",
      identifier: "FX",
    },
  ];
  return (
    <div className={styles.overallContainer}>
      <div className={styles.container}>
        {list.map((li) => (
          <div
            className={styles.griditem}
            key={li.text}
            role="button"
            onClick={() => {
              if (!li.nav) return;
              if (
                li.identifier !== "ELIGIBILITY" &&
                !localStorage.getItem("token")
              ) {
                history.push(`/signin?redirect=${encodeURIComponent(li.nav)}`);
              } else {
                history.push(li.nav);
              }
            }}
          >
            <div
              className={styles["grid-item-circle"]}
              style={{ backgroundColor: li.color }}
            >
              <img src={li.logo} />
            </div>
            <span className={styles["grid-item-text"]}>{li.text}</span>
            {li.identifier === "FX" ? (
              <div className={styles["griditem-grayed"]} />
            ) : (
              ""
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MortgageCategories;
